import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-paid',
  templateUrl: './icon-paid.component.html',
  styleUrls: ['./icon-paid.component.scss']
})
export class IconPaidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
